import { NgIf } from '@angular/common';
import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js/auto';
import { AggregatesService } from 'projects/chat-common/src/lib/services/aggregates.service';

@Component({
  selector: 'app-wellness-chart',
  standalone: true,
  templateUrl: './wellness-chart.component.html',
  styleUrls: ['./wellness-chart.component.scss'],
  imports: [NgIf]
})
export class WellnessChartComponent implements OnInit {
  @Input() type!: 'sleep' | 'activity' | 'steps';
  @ViewChild('chartCanvas') chartCanvas!: ElementRef<HTMLCanvasElement>;

  private chart!: Chart;
  private chartConfig!: ChartConfiguration;
  loading = true;
  noData = false;

  constructor(private wellnessService: AggregatesService) { }

  async ngOnInit() {
    const days = await this.wellnessService.fetchLast7DaysForType(this.type);

    if (days.length === 0) {
      this.noData = true;
    } else {
      this.chartConfig = this.buildChartConfig(this.type, days);
    }

    this.loading = false;

    setTimeout(() => {
      if (!this.noData && this.chartCanvas) {
        this.chart = new Chart(this.chartCanvas.nativeElement, this.chartConfig);
      }
    });
  }


  private buildChartConfig(type: 'sleep' | 'activity' | 'steps', days: any[]): ChartConfiguration {
    switch (type) {
      case 'sleep':
        return {
          type: 'bar',
          data: {
            labels: days.map(d => d.day),
            datasets: [
              { label: 'Deep', data: days.map(d => d.sleep?.deepMinutes ?? 0), backgroundColor: '#2E01AC' },
              { label: 'Light', data: days.map(d => d.sleep?.lightMinutes ?? 0), backgroundColor: '#7B4AE2' },
              { label: 'Nap', data: days.map(d => d.sleep?.napMinutes ?? 0), backgroundColor: '#FFC857' }
            ]
          },
          options: { responsive: true, plugins: { title: { display: true, text: 'Sleep (minutes)' } } }
        };

      case 'activity':
        return {
          type: 'bar',
          data: {
            labels: days.map(d => d.day),
            datasets: [
              { label: 'Active Minutes', data: days.map(d => d.activity?.activeMinutes ?? 0), backgroundColor: '#FE8F77' }
            ]
          },
          options: { responsive: true, plugins: { title: { display: true, text: 'Activity (minutes)' } } }
        };

      case 'steps':
        return {
          type: 'bar',
          data: {
            labels: days.map(d => d.day),
            datasets: [
              { label: 'Steps', data: days.map(d => d.steps?.totalSteps ?? 0), backgroundColor: '#FFC857' }
            ]
          },
          options: { responsive: true, plugins: { title: { display: true, text: 'Steps' } } }
        };
    }
  }

}
